<template>
  <div class="pic-dipendenti">

    <!-- Titolo -->
    <div class="section-header">
      <div class="section-title">
        DIPENDENTI CON ACQUISTI ({{ totaleDipendenti }})
      </div>
      <b-input-group
        size="sm"
        class="dip-filter"
      >
        <b-form-input
          v-model="filter"
          placeholder="Cerca dipendente o C.F..."
        />
        <b-input-group-append v-if="filter">
          <b-button
            variant="outline-secondary"
            @click="filter = ''"
          >
            ×
          </b-button>
        </b-input-group-append>
      </b-input-group>
    </div>
    <div class="section-divider"></div>
    <div class="table-wrapper">
      <b-table
        responsive
        small
        thead-class="thead-dark"
        class="dip-table"
        :items="listaDipendenti"
        :fields="fields"
        :filter="filter"
        :filter-included-fields="filterFields"
        sort-by="nome"
        sort-direction="asc"
        tbody-tr-class="employee-row"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nome)="data">
          <span class="dipendente-name">
            {{ data.item.nome }}
          </span>
        </template>

        <template v-slot:cell(codice_fiscale)="data">
          <span class="cf-value">
            {{ data.item.codice_fiscale }}
          </span>
        </template>

        <template v-slot:cell(totale_speso)="data">
          {{ formatEuro(data.item.totale_speso) }}
        </template>

        <template v-slot:cell(transazioni)="data">
          <span class="trans-badge">
            {{ data.item.transazioni.length }}
          </span>
        </template>

        <template v-slot:cell(azioni)="data">
          <b-button
            size="sm"
            class="btn-spese"
            @click.stop="toggleRow(data.item.id, $event)"
          >
            {{ openRow === data.item.id ? "- Spese" : "+ Spese" }}
          </b-button>
        </template>

        <template v-slot:row-details="data">
          <div class="spese-row">
            <PICSpeseDipendenti
              :transazioni="data.item.transazioni"
            />
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import PICSpeseDipendenti from "./PICSpeseDipendenti.vue";
export default {

  name: "PICDipendenti",
  components: {
    PICSpeseDipendenti
  },

  data() {
    return {
      openRow: null,
      filter: null,
      // Limita la ricerca a nominativo e codice fiscale del dipendente.
      filterFields: [
        "nome",
        "codice_fiscale"
      ],
      // Configurazione delle colonne della tabella.
      // Le colonne ordinabili utilizzano il sorting nativo di BootstrapVue.
      fields: [
        {
          key: "nome",
          label: "DIPENDENTE",
          sortable: true
        },
        {
          key: "codice_fiscale",
          label: "CODICE FISCALE",
          sortable: true,
          class: "text-center cf-col"
        },
        {
          key: "totale_speso",
          label: "TOTALE SPESO",
          sortable: true,
          class: "text-right importo-col"
        },
        {
          key: "transazioni",
          label: "TRANS.",
          sortable: true,
          class: "text-center trans-col",
          sortByFormatted: true,
          formatter: (value) => {
            return value ? value.length : 0;
          }
        },
        {
          key: "azioni",
          label: "",
          sortable: false,
          class: "text-center button-col"
        }
      ]
    };
  },

  props: {
    dipendenti: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    listaDipendenti() {
      return this.dipendenti.dipendenti || [];
    },

    totaleDipendenti() {
      return this.listaDipendenti.length;
    }
  },

  methods: {

    // Formatta l'importo in euro con separatore delle migliaia e due decimali
    formatEuro(value) {

      const numero = new Intl.NumberFormat(
        "it-IT",
        {
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(value || 0);

      return `€ ${numero}`;

    },
    // Il click sulla riga apre o chiude il dettaglio delle spese.
    rowClicked(dipendente) {
      this.toggleRow(dipendente.id);
    },
    // Mantiene aperto il dettaglio di un solo dipendente alla volta.
    toggleRow(id, event) {

      if (event && event.currentTarget) {
        event.currentTarget.blur();
      }

      if (this.openRow === id) {

        this.openRow = null;

        this.listaDipendenti.forEach((dipendente) => {
          // _showDetails è la proprietà utilizzata da b-table
          // per visualizzare lo slot row-details della riga selezionata.
          this.$set(dipendente, "_showDetails", false);
        });

        return;
      }

      this.openRow = id;

      this.listaDipendenti.forEach((dipendente) => {
        this.$set(
          dipendente,
          "_showDetails",
          dipendente.id === id
        );
      });
    }
  }
};
</script>

<style scoped>

.pic-dipendenti{
    width:100%;
}

.section-title{
    font-size:14px;
    font-weight:600;
    color:#373F66;
    margin-bottom:4px;
}

.section-header{
    display:flex;
    align-items:center;
    justify-content:space-between;
    margin-bottom:4px;
}

.section-header .section-title{
    margin-bottom:0;
}

.dip-filter{
    width:260px;
    flex:0 0 260px;
}

.section-divider{
    height:2px;
    background:#373F66;
    margin-bottom:10px;
}

.table-wrapper{
    background:#fff;
    border:1px solid #e5e5e5;
    border-radius:8px;
    overflow:hidden;
    /* Mantiene un'altezza minima durante il filtro evitando che lo scroll vada troppo in basso
    non rendendo chiaro all'utente, all'apertura del dettaglio, che deve spostarsi in basso per visualizarlo */
    min-height:150px;
}

.dip-table{
    margin-bottom:0;
}

.pic-dipendenti >>> .dip-table thead th {
    background-color:#373F66 !important;
    color:white !important;
    font-size:13px !important;
    font-weight:600 !important;
    border:0 !important;
    vertical-align:middle;
    /* Aumenta l'altezza dell'header della tabella */
    padding-top:10px !important;
    padding-bottom:10px !important;
}
/* Mantiene allineati titolo e contenuto della prima colonna */
.pic-dipendenti >>> .dip-table thead th:first-child,
.pic-dipendenti >>> .dip-table tbody td:first-child {
  padding-left:20px !important;
}

.dip-table tbody td{
    vertical-align:middle;
    font-size:13px;
}

.dip-table tbody tr:hover{
    background:#f7f9fc;
}

.text-right{
    text-align:right;
}

.text-center{
    text-align:center;
}

.dipendente-name {
  font-weight:600;
  font-size: 13px!important;
}

.trans-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgb(232, 245, 252);
  color: rgb(42, 170, 226);
  font-weight: 700;
  font-size: 13px;
}

.btn-spese,
.btn-spese:focus,
.btn-spese:active,
.btn-spese.focus,
.btn-spese:not(:disabled):not(.disabled):active {
  background: #fff;
  color: rgb(42,170,226);
  border-color: rgb(42,170,226);
  box-shadow: none;
}

.btn-spese:hover {
  background: #373F66;
  border-color: #373F66;
  color: #fff;
}

.employee-row {
  cursor: pointer;
}

.spese-row {
  padding: 8px 0px 8px 0px;
  background: #f8fafc;
}

.cf-col{
    width:200px;
    white-space:nowrap;
}

.cf-value {
  font-size: 13px !important;
}

.importo-col{
    width:150px;
    padding-right: 40px !important;
    white-space:nowrap;
}

.trans-col{
    width:90px;
}

.button-col{
    width:110px;
}

</style>